export enum ContainerRemoveStrategy {
  All = 'all',
  MoveChildrenToParent = 'move-children-to-parent',
  OnlyChildren = 'only-children'
}
